const URL_PARAM_PATTERN = /:(?<param>\w+)/g;
const DUPLICATE_SLASH_PATTERN = /\/\/+/g;
const REDUNDANT_SLASH_PATTERN = /\/$/g;

export function applyTemplate(template, params = {}, queryParams = {}) {
  let result = template;
  const templateParams = extractTemplateParams(template);

  for (const key of templateParams) {
    const paramValue = params[key] || '';
    const pattern = new RegExp(`:${key}`, 'g');

    result = result.replace(pattern, paramValue);
  }

  result = result.replace(DUPLICATE_SLASH_PATTERN, '/').replace(REDUNDANT_SLASH_PATTERN, '');

  const queryString = new URLSearchParams(queryParams).toString();

  if (queryString) {
    result += `?${queryString}`;
  }

  return result;
}

export function extractTemplateParams(template) {
  const matches = [];
  let match = URL_PARAM_PATTERN.exec(template);

  while (match) {
    if (match[1]) {
      matches.push(match[1]);
    }

    match = URL_PARAM_PATTERN.exec(template);
  }

  return matches;
}

export default {
  applyTemplate,
  extractTemplateParams,
};
